import { getApiErrorMessage } from "@/api";
import { hardNavigate } from "@/utils/hardNavigate";

type RedirectResult = { isRedirecting: true } | { isRedirecting: false; error: string | null };

/**
 * Fetches a URL and sends the whole page there. Not redirecting without an error means the
 * request was aborted or returned no URL.
 */
export async function redirectTo(
  getUrl: () => Promise<{ url?: string }>,
  signal?: AbortSignal,
): Promise<RedirectResult> {
  try {
    const { url } = await getUrl();
    if (signal?.aborted || !url) return { isRedirecting: false, error: null };

    hardNavigate(url);
    return { isRedirecting: true };
  } catch (err) {
    return { isRedirecting: false, error: signal?.aborted ? null : getApiErrorMessage(err) };
  }
}
